<script setup lang="ts" name="AdminAcceptUserStepperFooter">
import StepperFooterLayout from '~/components/StepperFooterLayout.vue';
</script>

<template>
  <div class="mt-2 shadow">
    <StepperFooterLayout>
      <slot />
    </StepperFooterLayout>
  </div>
</template>
